module.exports = __webpack_public_path__ + "static/media/arrow-down.c07b6914.svg";